import React from "react";
import { Chip, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const ReadinessChip = ({ percentage }) => {
  // Define color themes based on percentage ranges
  const getChipProperties = (percentage) => {
    if (percentage >= 85) {
      return {
        backgroundColor: "#E8FBF3",
        textColor: "#057F28",
        icon: <CheckCircleOutlineIcon fontSize="small" />,
      };
    } else if (percentage >= 60) {
      return {
        backgroundColor: "#E5F7FF",
        textColor: "#0277BD",
        icon: <TrendingUpIcon fontSize="small" />,
      };
    } else if (percentage >= 30) {
      return {
        backgroundColor: "#FFF7E0",
        textColor: "#B7791F",
        icon: <WarningAmberIcon fontSize="small" />,
      };
    } else {
      return {
        backgroundColor: "#FEEBEB",
        textColor: "#C71414",
        icon: <ErrorOutlineIcon fontSize="small" />,
      };
    }
  };

  const { backgroundColor, textColor, icon } = getChipProperties(percentage);

  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      {/* Progress background */}
      <Box
        sx={{
          position: "absolute",
          height: "100%",
          width: `${percentage}%`,
          maxWidth: "100%",
          backgroundColor: `${textColor}15`,
          left: 0,
          top: 0,
          zIndex: 0,
        }}
      />

      {/* Main chip */}
      <Chip
        icon={icon}
        label={`${percentage}%`}
        sx={{
          minWidth: "90px",
          height: "28px",
          backgroundColor: backgroundColor,
          color: textColor,
          fontWeight: 600,
          fontSize: "0.75rem",
          border: "none",
          borderRadius: 0,
          position: "relative",
          zIndex: 1,
          boxShadow: `0 2px 4px ${textColor}15`,
          transition: "all 0.2s ease",
          "& .MuiChip-icon": {
            color: textColor,
            marginLeft: "8px",
          },
          "&:hover": {
            boxShadow: `0 3px 6px ${textColor}25`,
          },
        }}
      />
    </Box>
  );
};

export default ReadinessChip;
